<template>
  <div>
    <MapModal
      :modalNode="modalNode"
      title="矢量数据"
      id="shpModel"
      :class="{
        isShowIcon: $store.state.isPresentationMode,
      }"
      :close="scenerModelClose"
      ref="mapModal"
      class="newModelPosition hierarchy1"
    >
      <template
        slot="head"
        v-if="!$store.state.isPresentationMode && posCode != 'guest'"
      >
        <div class="head-operate" v-if="selectedScene">
          <el-button type="primary" @click="addShpKmlGrouping">
            <i class="el-icon-zengjia"></i> 新建分组
          </el-button>
          <el-button type="primary" @click="importList">
            <i class="el-icon-zengjia"></i> 导入数据
          </el-button>
        </div>
      </template>
      <template
        slot="foot"
        v-if="!$store.state.isPresentationMode && posCode != 'guest'"
      >
        <div class="foot-operate" v-if="selectedScene">
          <el-button type="primary" @click="verification">加入场景</el-button>
        </div>
      </template>
    </MapModal>
    <newGroupingShpKml
      v-if="isAutoComplete"
      v-show="isNewGrouping"
      :isAutoComplete="isAutoComplete"
      @closeNewGrouping="isNewGrouping = false"
      @addNewGroupingSuccess="init"
      ref="newGroupingRef"
    ></newGroupingShpKml>
    <vectorAddKml
      v-if="isSecondaryAdd"
      v-show="isVectorAddKml"
      :isSecondaryAdd="isSecondaryAdd"
      @closeNewGrouping="isVectorAddKml = false"
      @addKmlOrShpSuccess="init"
      ref="vectorAddKmlRef"
    >
    </vectorAddKml>
    <updateVector
      v-if="isUpdateVector"
      :closeUpdateVector="
        () => {
          isUpdateVector = false;
          updateType = null;
        }
      "
      :updateType="updateType"
      @updateSuccess="init"
      @closeCurrentData="displayKmlOrShp($event, false)"
    >
    </updateVector>
  </div>
</template>
<script>
/* 异步加载 一些弹窗组件 */
const MapModal = () => import("@/components/common/mapModal/Index");
const TreeFilter = () => import("@/components/common/tree/Filter");
const newGroupingShpKml = () => import("./newGroupingShpKml.vue");
const vectorAddKml = () =>
  import("@/components/tables/vectorAddKml/VectorAddKml.vue");
const vectorAddShp = () =>
  import("@/components/tables/vectorAddShp/VectorAddShp.vue");
const updateVector = () => import("./updateVector.vue");
//按需加载
import {
  getProjectKmlAndShpInfo,
  addBimPlanScenesBusiness,
  deleteKmlList,
  deleteShpList,
  checkBeforeAddList,
  plotCheckBeforeAddList,
  // getModelPropertyList,
} from "@/api/api";
import * as mapWork from "./map.js";
import * as kmlMap from "@/components/tables/program/map.js";
import * as shpInfoListMap from "@/components/tables/shpInfoList/map.js";
import * as indexedDbMap from "@/components/tables/indexedDb/map.js";

export default {
  name: "shp-model",
  components: {
    MapModal,
    TreeFilter,
    newGroupingShpKml,
    vectorAddKml,
    vectorAddShp,
    updateVector,
  },
  props: {
    // 刷新
    getSchemeTree: { type: Function },
    // 场景数据
    selectedScene: { type: Object },
    // 资源树
    modalNodeData: { type: Array },
    // 关闭
    close: {
      type: Function,
    },
  },
  data() {
    return {
      show: false,
      filterText: "",
      checkedIds: [], //页面加载时默认勾选的id
      data: [],
      defaultProps: {
        children: "children",
        label: "title",
      },
      modalNode: {
        shp: {
          show: true, // 默认展示
          loading: false, // 加载loading
          // offset: {
          //   // 默认弹出层偏移
          //   x: 55,
          //   y: -418,
          //   // unit: "px", // 默认px
          // },
          width: "380px", // 宽度配置 默认450px
          height: `${window.screen.height - 200 - 126}px`, // 配置模态框中心高度
          // height: "350px",
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: true,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
          // 模态框中心配置
          content: {
            type: "tree", // 模态框内容类型 关键
            id: "shpTree", // id和ref使用的同一个
            name: "title", // 树的展示字段 默认name
            expand: true,
            // 树形Json 后台接受的具体数据 核心
            treeDataJson: [],
            checkeArr: [],
            search: {
              keywords: "title", // 搜素配置关键字 默认是name
            },
            checkBox: true,
            // checkBoxClick:
            //   $route.params.stype.indexOf("sandbox") < 0
            //     ? this.displayKmlOrShp
            //     : "",
            nodeClick:
              this.$route.params.stype.indexOf("sandbox") < 0
                ? () => {}
                : this.nodeClick,
          },
        },
      },
      projectId: window.sessionStorage.getItem("nowProjectId"),
      isNewGrouping: false,
      isVectorAddKml: false,
      isUpdateVector: false,
      updateType: null,
      isAutoComplete: {
        isShow: true,
      },
      isSecondaryAdd: {
        isShow: true,
      },
      posCode: window.sessionStorage.getItem("posCode"),
    };
  },
  // 监听，为了解决shp和kml的加载问题
  watch: {
    modalNodeData(newValue, oldValue) {
      this.checkedIds = [];
      if (newValue[3].children.length > 0) {
        newValue[3].children.forEach((item) => {
          item.value = item.infoFile.businessType;
          this.checkedIds.push(item.id);
        });
      }
      this.$refs.mapModal.$refs.modalTree[0].checkChangeArr(this.checkedIds);
    },
  },
  methods: {
    // 更新文件
    updateVector(data) {
      this.isUpdateVector = true;
      this.updateType = data.obj;
    },
    // 新建分组
    addShpKmlGrouping(data) {
      this.isVectorAddKml = false;
      if (
        data &&
        (data.type == "addShpKmlGrouping" || data.type == "editShpKmlGrouping")
      ) {
        this.isAutoComplete = data.obj;
        this.isAutoComplete.isShow = false;
        if (data.type === "editShpKmlGrouping") {
          this.isAutoComplete.groupingEdit = true;
        }
      } else {
        this.isAutoComplete = {
          isShow: true,
        };
      }
      this.isNewGrouping = true;
      this.$nextTick(() => {
        this.$refs.newGroupingRef.editGrouping();
      });
    },
    // 导入数据
    importList(data) {
      this.isNewGrouping = false;
      if (
        data &&
        (data.type === "addShpKmlData" || data.type === "editShpKmlData")
      ) {
        this.isSecondaryAdd = data;
        this.isSecondaryAdd.isShow = false;
        if (data.type === "addShpKmlData") {
          this.isVectorAddKml = true;
          this.$nextTick(() => {
            this.$refs.vectorAddKmlRef.secondAdd();
          });
        }
        if (data.type === "editShpKmlData") {
          this.isSecondaryAdd.editKmlShpData = true;
          this.isVectorAddKml = true;
          this.$nextTick(() => {
            this.$refs.vectorAddKmlRef.secondAdd();
            this.$refs.vectorAddKmlRef.threeEdit();
          });
        }
      } else {
        this.isSecondaryAdd = {
          isShow: true,
        };
        this.isVectorAddKml = true;
        this.$nextTick(() => {
          this.$refs.vectorAddKmlRef.resetData();
        });
      }
    },

    // 把 kml 中的 label 转为图片存入 缓存
    simplifyKmlData(data) {
      let { id } = data;
      let { kmlUrl } = data.kmlInfo;
      kmlMap.simplifyKmlData(this.$GLOBAL.localResourcesPath + kmlUrl, id);
    },

    scenerModelClose() {
      this.close("shp");
    },
    // 单击行数据
    nodeClick(data) {
      if (data.value === "ShpInfo") {
        const model = this.$GLOBAL.map.getLayer(data.id, "modelId");
        if (model) {
          model.flyTo();
        }
      }
      if (data.value === "KmlInfo") {
        const model = this.$GLOBAL.map.getLayer(data.id, "Kmlid");
        if (model) {
          model.flyTo();
        }
      }
    },
    // 飞机icon
    aircraftClick(data, checked) {
      if (data.children.length === 0 && data.parentId !== 0) {
        if (data.value == "KmlInfo") {
          const model = this.$GLOBAL.map.getLayer(data.id, "Kmlid");
          if (model && checked == false) {
          } else if (checked == true) {
            kmlMap.showKmlLayerId(true, data.id);
          } else if (checked == "eye") {
            if (model) {
            } else {
              kmlMap.showKmlLayerId(true, data.id);
            }
          }
        }
        // shp
        if (data.value == "ShpInfo") {
          const model = this.$GLOBAL.map.getLayer(data.id, "modelId");
          if (model && checked == false) {
          } else if (checked == true) {
            shpInfoListMap.showChinaLineId(true, data.id);
          } else if (checked == "eye") {
            if (model) {
            } else {
              shpInfoListMap.showChinaLineId(true, data.id);
            }
          }
        }
      }
      this.nodeClick(data);
    },
    // 点击眼睛显示隐藏
    displayKmlOrShp(data, checked) {
      // kml
      console.log(data, checked);
      if (data.children.length === 0 && data.parentId !== 0) {
        if (data.value == "KmlInfo") {
          const model = this.$GLOBAL.map.getLayer(data.id, "Kmlid");
          // 把销毁改成隐藏
          if (model?.show && checked == false) {
            kmlMap.showKmlLayerId(false, data.id);
          } else if (!model?.show && checked == true) {
            kmlMap.showKmlLayerId(true, data.id);
          } else if (checked == "eye") {
            if (model?.show) {
              kmlMap.showKmlLayerId(false, data.id);
            } else {
              kmlMap.showKmlLayerId(true, data.id);
            }
          }
        }
        // shp
        if (data.value == "ShpInfo") {
          const model = this.$GLOBAL.map.getLayer(data.id, "modelId");
          if (model && checked == false) {
            shpInfoListMap.showChinaLineId(false, data.id);
          } else if (checked == true) {
            shpInfoListMap.showChinaLineId(true, data.id);
          } else if (checked == "eye") {
            if (model) {
              shpInfoListMap.showChinaLineId(false, data.id);
            } else {
              shpInfoListMap.showChinaLineId(true, data.id);
            }
          }
        }
      }
    },
    // 勾选
    checkBoxClick(e, b) {
      // kml
      console.log(e);
      if (e.value == "KmlInfo") {
        kmlMap.showKmlLayerId(b, e.id);
      }
      // shp
      if (e.value == "ShpInfo") {
        shpInfoListMap.showChinaLineId(b, e.id);
      }
    },
    // 删除数据
    deleteKmlAndShp(data) {
      this.$confirm("确认删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (data.children.length > 0) {
            this.$notify({
              title: "当前节点具有子级，无法删除",
              message: "",
              type: "error",
              duration: 960,
              offset: 320,
            });
            return;
          }
          if (data.value === "KmlInfo") {
            const params = {
              projectId: window.sessionStorage.getItem("nowProjectId"),
              businessType: "KmlInfo",
              businessId: data.id,
            };
            plotCheckBeforeAddList(params).then((res) => {
              if (!res.data.data) {
                deleteKmlList({ id: data.id }).then((res) => {
                  if (res.data.code == 200 || res.data.code == 204) {
                    this.$notify({
                      title: "删除成功",
                      message: "",
                      type: "success",
                      duration: 960,
                      offset: 320,
                    });
                    this.displayKmlOrShp(data, false);
                    this.init();
                  }
                });
              } else {
                // 通知栏
                this.$message({
                  showClose: true,
                  message: `该矢量已在方案汇报中使用，无法删除，请检查`,
                  duration: 0,
                  type: "error",
                });
              }
            });
          }
          if (data.value === "ShpInfo") {
            const params = {
              projectId: window.sessionStorage.getItem("nowProjectId"),
              businessType: "ShpInfo",
              businessId: data.id,
            };
            plotCheckBeforeAddList(params).then((res) => {
              if (!res.data.data) {
                deleteShpList({ id: data.id }).then((res) => {
                  if (res.data.code == 200 || res.data.code == 204) {
                    this.$notify({
                      title: "删除成功",
                      message: "",
                      type: "success",
                      duration: 960,
                      offset: 320,
                    });
                    this.displayKmlOrShp(data, false);
                    this.init();
                  }
                });
              } else {
                // 通知栏
                this.$message({
                  showClose: true,
                  message: `该矢量已在方案汇报中使用，无法删除，请检查`,
                  duration: 0,
                  type: "error",
                });
              }
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消",
          });
        });
    },
    getShp() {
      // this.removeAllChange();

      let data = {
        projectId: window.sessionStorage.getItem("nowProjectId"),
      };
      getProjectKmlAndShpInfo(data)
        .then((res) => {
          const list = res.data.data;
          // 一级分组
          const oneGrouping = {
            i_icon: "small-operation-btn el-icon-plus",
            click: (e) =>
              this.addShpKmlGrouping({ obj: e, type: "addShpKmlGrouping" }),
          };
          // 二级分组新增编辑删除
          const operateGroupingList = [
            {
              i_icon: "small-operation-btn el-icon-plus",
              click: (e) => this.importList({ obj: e, type: "addShpKmlData" }),
            },
            {
              i_icon: "small-operation-btn el-icon-edit",
              click: (e) =>
                this.addShpKmlGrouping({ obj: e, type: "editShpKmlGrouping" }),
            },
            {
              i_icon: "small-operation-btn el-icon-delete",
              click: this.deleteKmlAndShp,
            },
          ];
          // 三级分组的编辑

          const threeObj = {
            i_icon: "small-operation-btn el-icon-edit",
            click: (e) => this.importList({ obj: e, type: "editShpKmlData" }),
          };
          const updateObj = {
            i_icon: "small-operation-btn el-icon-upload",
            click: (e) =>
              this.updateVector({ obj: e, type: "updateVectorShpKmlData" }),
          };
          // 三级分组的眼睛
          let threeObj2 = {};
          if (this.$route.params.stype.indexOf("sandbox") < 0) {
            //脚本
            threeObj2 = {
              i_icon: "small-operation-btn el-icon-view",
              click: (e) => this.displayKmlOrShp(e, "eye"),
            };
          } else {
            // 沙盘
            threeObj2 = {};
          }

          // 三级分组飞机
          let aircraft = {};
          if (this.$route.params.stype.indexOf("sandbox") < 0) {
            //脚本
            aircraft = {
              i_icon: "small-operation-btn el-icon-airplane",
              click: (e) => this.aircraftClick(e, "eye"),
            };
          } else {
            // 沙盘
            aircraft = {};
          }

          const labelList = [];
          const labelListChecked = [];
          let isDisplay;
          list.forEach((item) => {
            if (this.posCode != "guest") {
              item.operate = [oneGrouping];
            }
            item.children.forEach((etem) => {
              if (this.posCode != "guest")
                if (
                  (etem.kmlInfo && etem.kmlInfo.type) ||
                  (etem.shpInfo && etem.shpInfo.type)
                ) {
                  etem.operate = operateGroupingList;
                } else {
                  etem.operate = [
                    operateGroupingList[1],
                    operateGroupingList[2],
                  ];
                }

              if (etem.children && etem.children.length > 0) {
                etem.children.forEach((ytem) => {
                  if (ytem.kmlInfo) {
                    ytem.url =
                      this.$GLOBAL.localResourcesPath + ytem.kmlInfo.kmlUrl;
                  } else {
                    ytem.url =
                      this.$GLOBAL.localResourcesPath + ytem.shpInfo.shpUrl;
                  }
                  bimVector.pushVector(ytem);
                  labelList.push(ytem);
                  // 沙盘
                  if (this.$route.params.stype.indexOf("sandbox") > -1) {
                    isDisplay =
                      ytem.value == "KmlInfo"
                        ? ytem.kmlInfo.isDisplay
                        : ytem.shpInfo.isDisplay;
                    if (isDisplay) {
                      this.checkedIds.push(ytem.id);
                      labelListChecked.push(ytem);
                    }
                  }
                  console.log("kml数据", kmlMap.bigKmlData.indexOf(ytem.id));
                  if (this.posCode != "guest")
                    if (kmlMap.bigKmlData.indexOf(ytem.id) == -1) {
                      ytem.operate = [
                        aircraft,
                        threeObj2,
                        threeObj,
                        updateObj,
                        operateGroupingList[2],
                      ];
                    } else {
                      // <i class="las la-cloud-download-alt"></i>
                      if (this.posCode != "guest")
                        ytem.operate = [
                          threeObj,
                          {
                            i_icon:
                              "small-operation-btn las la-cloud-download-alt",
                            click: (e) => this.simplifyKmlData(e),
                          },
                          operateGroupingList[2],
                        ];
                    }
                });
              }
            });
          });
          this.modalNode.shp.content.treeDataJson = list;
          mapWork.getshpAll(list[1].children);

          // 沙盘
          let timeFun;
          clearTimeout(timeFun);
          if (this.$route.params.stype.indexOf("sandbox") > -1) {
            this.modalNode.shp.content.checkBoxClick = this.displayKmlOrShp;
            this.modalNode.shp.content.checkeArr = this.checkedIds;
          }

          this.$GLOBAL.labelListTree = labelList;
          // 循环输出默认值
          timeFun = setTimeout(() => {
            labelListChecked.forEach((item) => {
              this.displayKmlOrShp(item, true);
            });
          }, 1000);
        })
        .catch((res) => {
          console.log(res);
        });
    },
    checkAllChange() {
      this.$refs.mapModal.$refs.modalTree[0].checkAllChange();
    },
    removeAllChange() {
      this.$refs.mapModal.$refs.modalTree[0].removeAllChange();
    },
    verification() {
      this.onSubmit();
    },
    // 加入场景
    onSubmit() {
      let currentNode = this.$refs.mapModal.$refs.modalTree[0].getCurrentNode();
      let kmlBusinessId = [];
      let shpBusinessId = [];
      currentNode.forEach((item) => {
        if (item.value == "KmlInfo") {
          kmlBusinessId.push(item.id);
        } else {
          shpBusinessId.push(item.id);
        }
      });
      let kmlData = {
        // 场景id
        scenesId: this.selectedScene.id,
        // 项目id
        projectId: window.sessionStorage.getItem("nowProjectId"),
        // 业务id
        businessIdLsit: kmlBusinessId,
        // 业务类型
        businessType: "KmlInfo",
      };
      let shpData = {
        // 场景id
        scenesId: this.selectedScene.id,
        // 项目id
        projectId: window.sessionStorage.getItem("nowProjectId"),
        // 业务id
        businessIdLsit: shpBusinessId,
        // 业务类型
        businessType: "ShpInfo",
      };

      const kml = new Promise((resolve, reject) => {
        checkBeforeAddList(kmlData).then((res) => {
          console.log(res.data.data);
          let { code, data } = res.data;
          if (code == 200 || code == 204) {
            if (data && data.cOperateIds.length > 0) {
              reject(
                `操作（ID：${data.pModelIds.toString()}）中使用了矢量：${data.dataName.join(
                  "，"
                )}。被占用资源无法取消勾选，请检查！`
              );
            } else {
              addBimPlanScenesBusiness(kmlData).then((res) => {
                resolve();
              });
            }
          }
        });
      });

      const shp = new Promise((resolve, reject) => {
        checkBeforeAddList(shpData).then((res) => {
          console.log(res.data.data);
          let { code, data } = res.data;
          if (code == 200 || code == 204) {
            if (data && data.cOperateIds.length > 0) {
              reject(
                `操作（ID：${data.pModelIds.toString()}）中使用了矢量：${data.dataName.join(
                  "，"
                )}。被占用资源无法取消勾选，请检查！`
              );
            } else {
              addBimPlanScenesBusiness(shpData).then((res) => {
                resolve();
              });
            }
          }
        });
      });
      Promise.all([kml, shp])
        .then((res) => {
          this.modalNode.shp.loading = false;
          this.getSchemeTree();
          this.$notify({
            title: "加入场景成功",
            message: "",
            type: "success",
            duration: 960,
            offset: 320,
          });
          this.scenerModelClose();
        })
        .catch((err) => {
          this.$message({
            showClose: true,
            message: err,
            duration: 0,
            type: "error",
          });
        });
    },
    init() {
      this.getShp();
    },
    initIndexDb() {
      console.log("创建数据库");
      let dbObjs = [
        //创建KML缓存数据库
        {
          name: "kmlDb",
          key: "id", //"options.Kmlid",
          isAutoIncrement: false, //主键是否自增
          isCreateIndex: true,
          isUnique: true,
        },
        //创建SHP缓存数据库
        {
          name: "shpDb",
          key: "id",
          isAutoIncrement: false, //主键是否自增
          isCreateIndex: true,
          isUnique: true,
        },
        //创建模型缓存数据库
      ];
      indexedDbMap.init(dbObjs, this.initIndexedDbCb);
    },
  },
  mounted() {
    // console.log("ZHANG");
    this.init();
    // this.initIndexDb();
  },
};
</script>

<style lang="scss" scoped>
.isShowIcon {
  /deep/ .el-icon-plus {
    display: none !important;
  }
  /deep/ .el-icon-edit {
    display: none !important;
  }
  /deep/ .el-icon-delete {
    display: none !important;
  }
  /deep/ .el-icon-upload {
    display: none !important;
  }
}
.head-operate {
  padding: 10px 10px;
  margin: 0 -5px !important;
  button {
    margin: 0 5px !important;
  }
}
.foot-operate {
  padding: 10px 10px;
  border-top: 1px solid rgba(245, 245, 245, 0.6) !important;
  justify-content: flex-end;
  align-items: center;
  display: flex;
  /deep/ .el-button {
    margin: 0 !important;
    font-size: 14px;
    padding: 1px 10px !important;
    line-height: 30px;
    height: 30px !important;
  }
}
</style>
